import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getApiBaseUrl, CHANGE_PASSWORD } from "../Config/Config";

const UserProfile = () => {
  const [userData, setUserData] = useState();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [isNewPasswordVisible, setNewPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [isOldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [passwordPolicy, setPasswordPolicy] = useState(null);
  const [oldPasswordModal, setOldPasswordModal] = useState(false);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const res = await fetch(`${getApiBaseUrl()}/getPasswordPolicy`);
        const data = await res.json();

        if (data?.ResultData) {
          setPasswordPolicy(data.ResultData);
        } else {
          console.error("No ResultData found in response", data);
        }
      } catch (err) {
        console.error("Error fetching password policy", err);
      }
    };

    fetchPolicy();
  }, []);
  console.log(passwordPolicy, "passss");

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    setUserData(user);
  }, []);

  const toggleNewPasswordVisibility = () => {
    setNewPasswordVisible((prevState) => !prevState);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible((prevState) => !prevState);
  };

  const toggleOldPasswordVisibility = () => {
    setOldPasswordVisible((prevState) => !prevState);
  };

  const handleConfirmChange = async () => {
    setSubmitLoading(true);
    const payload = {
      username: userData?.UserName,
      new_password: newPassword,
      old_password: oldPassword,
      PerformedBy: userData?.UserId?.toString(),
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}${CHANGE_PASSWORD}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (res.ok && result.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: result.Message || "Password changed successfully!",
          confirmButtonText: "OK",
        }).then(() => {
          Swal.fire({
            icon: "info",
            title: "Redirecting to Sign In",
            text: "You will be taken back to the login screen.",
            timer: 2000,
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/signin";
          }, 2000);
        });

        // document.getElementById("oldPasswordModalClose").click();

        // Optional: Reset fields
        setNewPassword("");
        setConfirmPassword("");
        setOldPassword("");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.Message || "Password change failed!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Something went wrong!",
      });
    }
    setSubmitLoading(false);
  };

  useEffect(() => {
    if (newPassword === confirmPassword && newPassword !== "") {
      setOldPasswordModal(true);
    } else {
      setOldPasswordModal(false);
    }
  }, [newPassword, confirmPassword]);

  const validatePassword = (pwd) => {
    if (!passwordPolicy) return "";

    const {
      MinLength,
      RequireUppercase,
      RequireLowercase,
      RequireDigit,
      RequireSpecialChar,
    } = passwordPolicy;

    if (pwd.length < MinLength) {
      return `Password must be at least ${MinLength} characters long.`;
    }
    if ((pwd.match(/[A-Z]/g) || []).length < RequireUppercase) {
      return `Password must contain at least ${RequireUppercase} uppercase letter(s).`;
    }
    if ((pwd.match(/[a-z]/g) || []).length < RequireLowercase) {
      return `Password must contain at least ${RequireLowercase} lowercase letter(s).`;
    }
    if ((pwd.match(/[0-9]/g) || []).length < RequireDigit) {
      return `Password must contain at least ${RequireDigit} digit(s).`;
    }
    if ((pwd.match(/[^A-Za-z0-9]/g) || []).length < RequireSpecialChar) {
      return `Password must contain at least ${RequireSpecialChar} special character(s) (!@#$%^&*()).`;
    }

    return "";
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);

    // validate only policy
    setNewPasswordError(validatePassword(value));

    // re-check confirm password if already typed
    if (confirmPassword && value !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    if (value !== newPassword) {
      setConfirmPasswordError("Passwords do not match");
    } else {
      setConfirmPasswordError("");
    }
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/assetmgt/dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item " aria-current="page">
                  Profile
                </h4>
              </ol>
            </nav>
            <h6>User Profile</h6>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h4>Profile</h4>
          </div>
          <div className="card-body profile-body">
            <div className="d-flex justify-content-between">
              <h5 className="mb-2">
                <i className="ti ti-user text-primary me-1" />
                User Information
              </h5>
              {oldPasswordModal ? (
                <Link
                  to="#"
                  title="save changes"
                  className="btn btn-primary btn-sm shadow-none"
                  data-bs-toggle="modal"
                  data-bs-target="#oldPasswordModal"
                >
                  <i className="fas fa-check fs-4"></i>
                </Link>
              ) : (
                <Link
                  to="#"
                  title="save changes"
                  className="btn btn-primary btn-sm shadow-none"
                >
                  <i className="fas fa-check fs-4"></i>
                </Link>
              )}
            </div>
            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">
                    Name<span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={userData?.Name}
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">
                    User ID<span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={userData?.UserName}
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">
                    New Password<span className="text-danger ms-1">*</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={isNewPasswordVisible ? "text" : "password"}
                      className="pass-input form-control"
                      placeholder="Enter new password"
                      value={newPassword}
                      onChange={handleNewPasswordChange}
                      required
                      autoComplete="new-password"
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                    />
                    <span
                      className={`ti toggle-password ${
                        isNewPasswordVisible ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={toggleNewPasswordVisibility}
                    ></span>
                  </div>
                  {newPasswordError && (
                    <div className="text-danger mt-1">{newPasswordError}</div>
                  )}
                </div>
              </div>

              <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">
                    Confirm Password<span className="text-danger ms-1">*</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={isConfirmPasswordVisible ? "text" : "password"}
                      className="pass-input form-control"
                      placeholder="Confirm new password"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      required
                      autoComplete="new-password"
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                    />
                    <span
                      className={`ti toggle-password ${
                        isConfirmPasswordVisible ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={toggleConfirmPasswordVisibility}
                    ></span>
                  </div>
                  {confirmPasswordError && (
                    <div className="text-danger mt-1">
                      {confirmPasswordError}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MODAL FOR OLD PASSWORD */}
      <div className="modal fade" id="oldPasswordModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Enter Old Password</h5>
              <i
                className="fa-solid fa-xmark"
                id="oldPasswordModalClose"
                data-bs-dismiss="modal"
              ></i>
            </div>
            <div className="modal-body">
              <div className="pass-group">
                <input
                  type={isOldPasswordVisible ? "text" : "password"}
                  className="pass-input form-control"
                  placeholder="Enter old password"
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  autoComplete="new-password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
                <span
                  className={`ti toggle-password ${
                    isOldPasswordVisible ? "ti-eye" : "ti-eye-off"
                  }`}
                  onClick={toggleOldPasswordVisibility}
                ></span>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button className="btn btn-success" onClick={handleConfirmChange}>
                {submitLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
